// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.report-dd {
  width: 25% !important;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 0.5%;
}
`, "",{"version":3,"sources":["webpack://./src/app/invoice/invoice-home/invoice-home.component.less"],"names":[],"mappings":"AAEA;EACI,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;AADJ","sourcesContent":["@import (reference) url(\"../../../styles.less\");\n\n.report-dd {\n    width: 25% !important;\n    padding-top: 10px;\n    padding-bottom: 10px;\n    padding-left: 0.5%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
